<template>
     <footer >
      <div>版权声明：本网站所刊内容未经本网站及作者本人许可，不得下载、转载或建立镜像等，违者本网站将追究其法律责任。本网站所用文字图片部分来源于公共网络或者素材网站，凡图文未署名者<br/>
        均为原始状况，但作者发现后可告知认领，我们仍会及时署名或依照作者本人意愿处理，如未及时联系本站，本网站不承担任何责任。  网站备案号： 闽ICP备20004409号-1<br/>
        热门搜索：自动喂料系统、智能饲养系统、养猪场喂料设备、养鸡场自动喂料系统、自动化养殖设备、智能喂养系统、智能称重喂养系统、自动称重喂养设备
      </div>
     </footer>
</template>

<script>
    export default {
        name: "Footer",
        data(){
          return {
            msg:''
          }
        }
    }
</script>

<style scoped>
  footer{
    font-size: 14px;
    text-align: center;
    line-height: 35px;
    background-color: #333333;
    color: #999999;
	
  }
  .beian{
  	/* text-decoration: none; */
  	 color: #999999!important;
  }
</style>
